import styled from 'styled-components';
import Icon from '../../../_shared/components/Icon';

export const StyledMakeModelFilter = styled.div`
  height: auto;
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.LIGHT_SILVER};
  display: flex;
  justify-content: space-between;
  padding: 18px 0;
  cursor: pointer;
  white-space: nowrap;
`;
export const Label = styled.span`
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
`;

export const FilterIndicator = styled.span`
  color: ${({ theme }) => theme.COLORS.TERTIARY};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
`;

export const RightArrow = styled(Icon).attrs({
  icon: 'TR5-Next_chev'
})`
  fill: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  width: 24px;
  height: 12px;
`;
